module.exports = __webpack_public_path__ + "img/double_circle_orange.0cca46cc.png";